// styled
import { styled } from '@mui/material/styles'
// Material
import { AppBar, Button, Toolbar, Typography } from '@mui/material'
// Icons
import { ArrowRightIcon, EditOutlinedIcon } from '$common/icons'
// Localization
import { t } from '$i18n'
// Helpers
import { closeMyAccount, openEditAccount } from '$logic/router'
import { getClientUserId } from '$logic/client-user'
import { RoundedOutlinedButton } from '$common/buttons'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: 58,
  padding: '8px 0 0',
  justifyContent: 'space-between',

  [theme.breakpoints.up('sm')]: {
    minHeight: 58,
    padding: '8px 0 0',
  },
}))

export const MyAccountAppBar = () => (
  <AppBar color="transparent" sx={{ margin: '0 auto' }}>
    <StyledToolbar disableGutters>
      <Button
        startIcon={<ArrowRightIcon sx={{ color: 'white' }} />}
        onClick={closeMyAccount}
      >
        <Typography color="white" variant="subtitle3">
          {t('myAccount.account')}
        </Typography>
      </Button>
      <RoundedOutlinedButton
        icon={<EditOutlinedIcon width={18} />}
        size={AvatarSize.XS}
        onClick={() => {
          if (getClientUserId()) openEditAccount()
        }}
        title={t('common.edit')}
        color="neutral000"
      />
    </StyledToolbar>
  </AppBar>
)
